module.exports = __webpack_public_path__ + "img/17.ac92d225.svg";